const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const KNOWN_DOMAINS = ['.collums.test', '.collums.dev', '.collums.co.uk'];
const COLLUMS_DOMAIN = KNOWN_DOMAINS.find(d => hostname.endsWith(d)) || '.collums.co.uk';

const COOKIE_KEYS = {
    EXP_TIME: 'expTime',
    LOGOUT_ACTIVE: 'logoutActive',
    TOKEN: 'token'
};

const LOCAL_STORAGE_KEYS = {
    TOKEN_KEY: 'token',
    USER_KEY: 'user'
};

module.exports = {
    COLLUMS_DOMAIN,
    COOKIE_KEYS,
    LOCAL_STORAGE_KEYS
};
